import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { format_time_for_rented_model } from '@/utils/utils_client';
import { useTranslation } from 'react-i18next';

interface Props {
  time_left: number;
  className?: string;
}

export function ViewDiffusionModelTimer({ time_left, className = '' }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  function render_view() {
    let out = null;

    let class_name_base = 'border rounded-lg text-[10px] px-1 py-[1px] h-[20px] flex items-center justify-center';

    if (time_left === 0) {
      out = (
        <span className={`border border-red-900 text-red-900 ${class_name_base}  ${className}`}>
          {t(i18n_base_ui.views.diffusion_model_timer_expired.title)}
        </span>
      );
    } else {
      out = (
        <span className={` border-component-border text-component-item-selected ${class_name_base} ${className}`}>
          {format_time_for_rented_model(time_left)}
        </span>
      );
    }

    return out;
  }

  return render_view();
}
